import { render, staticRenderFns } from "./AlternativeExerciseForm.vue?vue&type=template&id=57e8da6f&scoped=true"
import script from "./AlternativeExerciseForm.vue?vue&type=script&lang=js"
export * from "./AlternativeExerciseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8da6f",
  null
  
)

export default component.exports